import { TipoDespachoEnum } from "./Dte/TipoDespacho.enum";

export class GuiaDespacho {
   guiaDespachoId: string;
   facturableId: string;
   dteId: string;
   tipoTraslado: number;
   tipoDespacho: TipoDespachoEnum;
   rutTransporte: number;
   patente: string;
   rutChofer: number;
   dvChofer: string;
   dvTransporte: string;
   nombreChofer: string;
   nombreTipoTraslado: string;
   nombreTipoDespacho: string;
   anulado: boolean;
}
